import React, { useEffect, useCallback, useState, useRef, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRouteStore } from '../store/RouteConfigStore';
import { renderPanelContent } from './manualContent/index';

/* ── 타입 ── */

interface TocItem {
  num: string;
  text: string;
  key: string;
  children?: TocItem[];
}


/* ── TSP 데이터 ── */

const TSP_TOC: TocItem[] = [
  { num: '1.', text: '메인화면', key: 'tsp-1' },
  {
    num: '2.', text: '회원가입/로그인/계정찾기', key: 'tsp-2',
    children: [
      { num: '2.1.', text: '회원가입', key: 'tsp-2-1' },
      { num: '2.2.', text: '로그인', key: 'tsp-2-2' },
      { num: '2.3.', text: '아이디 찾기', key: 'tsp-2-3' },
      { num: '2.4.', text: '비밀번호 찾기/재설정', key: 'tsp-2-4' },
    ],
  },
  { num: '3.', text: 'AI 실증지원 소개', key: 'tsp-6' },
  {
    num: '4.', text: '실증장비 예약하기', key: 'tsp-4',
    children: [
      {
        num: '4.1.', text: '장비 검색', key: 'tsp-4-1',
        children: [
          { num: '4.1.1.', text: '장비 목록 조회', key: 'tsp-4-1-1' },
          { num: '4.1.2.', text: '장비 상세 조회', key: 'tsp-4-1-2' },
        ],
      },
      {
        num: '4.2.', text: '견적요청', key: 'tsp-4-2',
        children: [
          { num: '4.2.1.', text: '견적 요청 등록', key: 'tsp-4-2-1' },
          { num: '4.2.2.', text: '견적 요청 조회', key: 'tsp-4-2-2' },
        ],
      },
      {
        num: '4.3.', text: '장비 사용 및 사용료 납부', key: 'tsp-4-3',
        children: [
          { num: '4.3.1.', text: '사용 신청 등록', key: 'tsp-4-3-1' },
          { num: '4.3.2.', text: '사용 신청 조회', key: 'tsp-4-3-2' },
          { num: '4.3.3.', text: '예약 장비 사용 안내', key: 'tsp-4-3-3' },
          { num: '4.3.4.', text: '사용 종료 및 장비 반납', key: 'tsp-4-3-4' },
          { num: '4.3.5.', text: '사용료 고지 및 납부', key: 'tsp-4-3-5' },
        ],
      },
    ],
  },
  {
    num: '5.', text: '이용지원', key: 'tsp-7',
    children: [
      { num: '5.1.', text: '공지사항', key: 'tsp-7-1' },
      { num: '5.2.', text: '자주묻는질문', key: 'tsp-7-2' },
    ],
  },
  {
    num: '6.', text: '1:1 문의', key: 'tsp-8',
    children: [
      { num: '6.1.', text: '문의 등록', key: 'tsp-8-1' },
      { num: '6.2.', text: '문의 내역/답변 확인', key: 'tsp-8-2' },
    ],
  },
  { num: '7.', text: '대시보드', key: 'tsp-5' },
  {
    num: '8.', text: '회원정보관리', key: 'tsp-3',
    children: [
      { num: '8.1.', text: '회원정보 변경', key: 'tsp-3-1' },
      { num: '8.2.', text: '기업인증', key: 'tsp-3-2' },
      { num: '8.3.', text: 'SNS 로그인 연동', key: 'tsp-3-3' },
      { num: '8.4.', text: '회원탈퇴', key: 'tsp-3-4' },
    ],
  },
];


/* ── USP 데이터 ── */

const USP_TOC: TocItem[] = [
  { num: '1.', text: '메인화면', key: 'usp-1' },
  {
    num: '2.', text: '회원가입/로그인/계정찾기', key: 'usp-2',
    children: [
      { num: '2.1.', text: '회원가입', key: 'usp-2-1' },
      { num: '2.2.', text: '로그인', key: 'usp-2-2' },
      { num: '2.3.', text: '아이디 찾기', key: 'usp-2-3' },
      { num: '2.4.', text: '비밀번호 찾기/재설정', key: 'usp-2-4' },
    ],
  },
  {
    num: '3.', text: '회원정보관리', key: 'usp-3',
    children: [
      { num: '3.1.', text: '회원정보 변경', key: 'usp-3-1' },
      { num: '3.2.', text: '기업인증', key: 'usp-3-2' },
      { num: '3.3.', text: 'SNS 로그인 연동', key: 'usp-3-3' },
      { num: '3.4.', text: '회원탈퇴', key: 'usp-3-4' },
    ],
  },
  {
    num: '4.', text: '시설예약', key: 'usp-4',
    children: [
      { num: '4.1.', text: '시설안내', key: 'usp-4-1' },
      {
        num: '4.2.', text: '시설 이용신청', key: 'usp-4-2',
        children: [
          { num: '4.2.1.', text: 'AI 집적단지 이용신청', key: 'usp-4-2-1' },
          { num: '4.2.2.', text: 'AI 창업캠프 1·2호 이용신청', key: 'usp-4-2-2' },
        ],
      },
      {
        num: '4.3.', text: '시설예약관리', key: 'usp-4-3',
        children: [
          { num: '4.3.1.', text: 'AI 집적단지 예약 조회', key: 'usp-4-3-1' },
          { num: '4.3.2.', text: 'AI 창업캠프 1·2호 예약 조회', key: 'usp-4-3-2' },
        ],
      },
    ],
  },
  {
    num: '5.', text: '지원사업안내', key: 'usp-5',
    children: [
      { num: '5.1.', text: '국가사업안내', key: 'usp-5-1' },
    ],
  },
  {
    num: '6.', text: '코디네이팅·자문 신청', key: 'usp-6',
    children: [
      { num: '6.1.', text: '코디네이팅·자문 안내', key: 'usp-6-1' },
      { num: '6.2.', text: '코디네이팅 신청', key: 'usp-6-2' },
      { num: '6.3.', text: '코디네이팅 신청 내역', key: 'usp-6-3' },
      { num: '6.4.', text: '전문가 자문단 조회', key: 'usp-6-4' },
      { num: '6.5.', text: '전문가 자문 신청', key: 'usp-6-5' },
      { num: '6.6.', text: '전문가 자문 신청 내역', key: 'usp-6-6' },
    ],
  },
  { num: '7.', text: '대시보드', key: 'usp-7' },
  {
    num: '8.', text: '기업정보관리', key: 'usp-8',
    children: [
      { num: '8.1.', text: '기업정보 등록/변경', key: 'usp-8-1' },
      { num: '8.2.', text: '입주기업 성과조사', key: 'usp-8-2' },
      { num: '8.3.', text: '입주시설 조회', key: 'usp-8-3' },
    ],
  },
  {
    num: '9.', text: '자문단 활동관리 [자문단 전용]', key: 'usp-9',
    children: [
      { num: '9.1.', text: '자문단 지원', key: 'usp-9-1' },
      { num: '9.2.', text: '자문단 결과보고 제출', key: 'usp-9-2' },
    ],
  },
  {
    num: '10.', text: '이용지원', key: 'usp-10',
    children: [
      { num: '10.1.', text: '공지사항', key: 'usp-10-1' },
      { num: '10.2.', text: '소식/행사', key: 'usp-10-2' },
      { num: '10.3.', text: '뉴스레터', key: 'usp-10-3' },
      { num: '10.4.', text: '자주묻는질문', key: 'usp-10-4' },
      { num: '10.5.', text: '이벤트', key: 'usp-10-5' },
    ],
  },
  {
    num: '11.', text: '1:1 문의', key: 'usp-11',
    children: [
      { num: '11.1.', text: '문의 등록', key: 'usp-11-1' },
      { num: '11.2.', text: '문의 내역/답변 확인', key: 'usp-11-2' },
    ],
  },
];


/* ── 포털별 분기 ── */

function getDataByPortal(portal: string) {
  switch (portal) {
    case 'PORTAL_TSP':
      return { title: '목차', toc: TSP_TOC };
    case 'PORTAL_USP':
      return { title: '목차', toc: USP_TOC };
    default:
      return { title: '사용자 웹 매뉴얼 — 목차', toc: [] };
  }
}

/* ── 유틸 ── */

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function AnimatedCollapse({
  isOpen,
  className,
  children,
}: {
  isOpen: boolean;
  className: string;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const isFirst = useRef(true);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (isFirst.current) {
      isFirst.current = false;
      el.style.height = isOpen ? 'auto' : '0px';
      return;
    }

    if (isOpen) {
      el.style.height = 'auto';
      const h = el.scrollHeight;
      el.style.height = '0px';
      void el.offsetHeight;
      el.style.height = h + 'px';

      const onEnd = () => { el.style.height = 'auto'; };
      el.addEventListener('transitionend', onEnd, { once: true });
      return () => el.removeEventListener('transitionend', onEnd);
    } else {
      const h = el.scrollHeight;
      el.style.height = h + 'px';
      void el.offsetHeight;
      el.style.height = '0px';
    }
  }, [isOpen]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}

function findItem(items: TocItem[], key: string): TocItem | undefined {
  for (const item of items) {
    if (item.key === key) return item;
    if (item.children) {
      const found = findItem(item.children, key);
      if (found) return found;
    }
  }
  return undefined;
}

function collectChildKeys(items: TocItem[]): string[] {
  const keys: string[] = [];
  for (const item of items) {
    keys.push(item.key);
    if (item.children) keys.push(...collectChildKeys(item.children));
  }
  return keys;
}

function findPathKeys(items: TocItem[], key: string): string[] | null {
  for (const item of items) {
    if (item.key === key) return [item.key];
    if (item.children) {
      const childPath = findPathKeys(item.children, key);
      if (childPath) return [item.key, ...childPath];
    }
  }
  return null;
}

function buildExclusiveOpenPanels(toc: TocItem[], pathKeys: string[]) {
  const next: Record<string, boolean> = {};
  for (const k of collectChildKeys(toc)) next[k] = false;
  for (const k of pathKeys) next[k] = true;
  return next;
}

function TocList({
  items,
  onNavClick,
  isRoot = true,
}: {
  items: TocItem[];
  onNavClick: (key: string) => void;
  isRoot?: boolean;
}) {
  const UlTag = isRoot ? 'ul' : 'ul';
  return (
    <UlTag className={isRoot ? 'menual-nav' : undefined}>
      {items.map((item) => (
        <li key={item.key} id={`nav-${item.key}`}>
          <button
            type="button"
            className="menual-nav-btn"
            onClick={() => onNavClick(item.key)}
          >
            <span>{item.num}</span> {item.text}
          </button>
          {item.children && <TocList items={item.children} onNavClick={onNavClick} isRoot={false} />}
        </li>
      ))}
    </UlTag>
  );
}

/* ── 패널 트리 (재귀) ── */

function PanelTree({
  items,
  openPanels,
  togglePanel,
  onMoveTop,
  portal,
}: {
  items: TocItem[];
  openPanels: Record<string, boolean>;
  togglePanel: (key: string) => void;
  onMoveTop: (key: string) => void;
  portal: string;
}) {
  return (
    <ul className="menual-contents">
      {items.map((item) => {
        const content = renderPanelContent(portal, item.key);
        const hasBody = content !== null;
        return (
        <li key={item.key}>
          <div
            id={`panel-${item.key}`}
            className={`menual-panel${openPanels[item.key] ? ' active' : ''}`}
          >
            <div className="menual-panel-head">
              <button
                type="button"
                className="menual-panel-move-top"
                onClick={() => onMoveTop(item.key)}
              >
                {item.num}
              </button>
              <strong
                onClick={hasBody ? () => togglePanel(item.key) : undefined}
                style={hasBody ? { cursor: 'pointer' } : undefined}
              >
                {item.text}
              </strong>
              {hasBody && (
                <button
                  type="button"
                  className="menual-panel-control"
                  onClick={() => togglePanel(item.key)}
                />
              )}
            </div>
            {hasBody && (
              <AnimatedCollapse isOpen={!!openPanels[item.key]} className="menual-panel-body">
                {content}
              </AnimatedCollapse>
            )}
          </div>
          {item.children && openPanels[item.key] && (
            <PanelTree
              items={item.children}
              openPanels={openPanels}
              togglePanel={togglePanel}
              onMoveTop={onMoveTop}
              portal={portal}
            />
          )}
        </li>
        );
      })}
    </ul>
  );
}

/* ── 메인 컴포넌트 ── */

const UserManualSidebar: React.FC = () => {
  const location = useLocation();
  const portal = useRouteStore((s) => s.portal);
  const { title, toc } = getDataByPortal(portal);

  const [tocOpen, setTocOpen] = useState(true);
  const [openPanels, setOpenPanels] = useState<Record<string, boolean>>({});

  const prevPortalRef = useRef<string | null>(null);
  const lastKeyRef = useRef<string | null>(null);
  const navByManualLinkRef = useRef(false);

  const storageKey = `user-manual-state:${portal}`;

  const persistState = useCallback((next: { isOpen: boolean; tocOpen: boolean; openPanels: Record<string, boolean>; lastKey: string | null }) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
      // ignore
    }
  }, [storageKey]);

  const restoreState = useCallback(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return null;
      return JSON.parse(raw) as { isOpen?: boolean; tocOpen?: boolean; openPanels?: Record<string, boolean>; lastKey?: string | null };
    } catch {
      return null;
    }
  }, [storageKey]);

  const clearPersistedState = useCallback((opts?: { keepOpen?: boolean }) => {
    const keepOpen = !!opts?.keepOpen;
    lastKeyRef.current = null;
    setOpenPanels({});
    setTocOpen(true);
    try {
      if (keepOpen) {
        sessionStorage.setItem(storageKey, JSON.stringify({
          isOpen: true,
          tocOpen: true,
          openPanels: {},
          lastKey: null,
        }));
      } else {
        sessionStorage.removeItem(storageKey);
      }
    } catch {
      // ignore
    }
  }, [storageKey]);

  useEffect(() => {
    // 페이지 이동 시에도 사용자매뉴얼은 열린 상태 유지 (닫기 버튼 클릭 시에만 닫힘)
    // 포털이 바뀌었을 때만(메뉴 구조가 바뀌므로) 패널 상태를 초기화합니다.
    const saved = restoreState();
    if (saved) {
      if (saved.isOpen) {
        document.documentElement.classList.add('menual-active');
      }
      setTocOpen(saved.tocOpen ?? true);
      setOpenPanels(saved.openPanels ?? {});
      lastKeyRef.current = saved.lastKey ?? null;
      // 자동 스크롤은 "사이드바가 열린 상태"에서만 수행
      if (saved.lastKey && document.documentElement.classList.contains('menual-active')) {
        setTimeout(() => scrollToId(`panel-${saved.lastKey}`), 50);
      }
    } else if (prevPortalRef.current && prevPortalRef.current !== portal) {
      setTocOpen(true);
      setOpenPanels({});
      lastKeyRef.current = null;
    }
    prevPortalRef.current = portal;
  }, [portal]);

  useEffect(() => {
    // 페이지 이동 시에도 매뉴얼 패널 상태를 유지합니다.
    // 포털 전환 시 초기화는 위의 portal useEffect에서 처리됩니다.
    if (!document.documentElement.classList.contains('menual-active')) return;
    if (navByManualLinkRef.current) return;
    navByManualLinkRef.current = false;
  }, [location.pathname]);

  useEffect(() => {
    const isOpen = document.documentElement.classList.contains('menual-active');
    persistState({ isOpen, tocOpen, openPanels, lastKey: lastKeyRef.current });
  }, [tocOpen, openPanels, persistState]);

  useEffect(() => {
    // footer 클릭 등으로 class만 바뀌는 케이스도 저장/복원되도록 감지
    const el = document.documentElement;
    const obs = new MutationObserver(() => {
      const isOpen = el.classList.contains('menual-active');
      // 상태 변화 없이 열림만 바뀌어도 저장
      persistState({ isOpen, tocOpen, openPanels, lastKey: lastKeyRef.current });
    });
    obs.observe(el, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, [persistState, tocOpen, openPanels]);

  const togglePanel = useCallback((key: string) => {
    setOpenPanels((prev) => {
      const next = !prev[key];
      const updates: Record<string, boolean> = { [key]: next };
      const item = findItem(toc, key);
      if (item?.children) {
        for (const ck of collectChildKeys(item.children)) {
          updates[ck] = next;
        }
      }
      return { ...prev, ...updates };
    });
  }, [toc]);

  const handleNavClick = useCallback((key: string) => {
    const path = findPathKeys(toc, key) || [key];
    const item = findItem(toc, key);
    const childKeys = item?.children ? collectChildKeys(item.children) : [];
    lastKeyRef.current = key;
    setOpenPanels(buildExclusiveOpenPanels(toc, [...path, ...childKeys]));
    setTimeout(() => scrollToId(`panel-${key}`), 50);
  }, [toc]);

  const handleMoveTop = useCallback((key: string) => {
    setTocOpen(true);
    lastKeyRef.current = key;
    setTimeout(() => scrollToId(`nav-${key}`), 50);
  }, []);

  useEffect(() => {
    // 매뉴얼 본문 내 하이퍼링크 클릭 시에도 "현재 보고 있던 패널"을 기록해서
    // 페이지 이동 후 사이드바가 해당 패널 상태로 복원되도록 함.
    const onClick = (e: MouseEvent) => {
      const link = (e.target as HTMLElement | null)?.closest?.('.menual-link');
      if (!link) return;

      // 이 이동은 매뉴얼 링크로 인한 네비게이션이므로 "페이지 이동 초기화"를 막음
      navByManualLinkRef.current = true;
      window.setTimeout(() => {
        navByManualLinkRef.current = false;
      }, 0);

      const panel = (link as HTMLElement).closest?.('[id^="panel-"]') as HTMLElement | null;
      if (!panel?.id) return;
      const key = panel.id.replace(/^panel-/, '');
      if (!key) return;
      lastKeyRef.current = key;
      const path = findPathKeys(toc, key) || [key];
      setOpenPanels((prev) => {
        const next = { ...prev };
        for (const k of path) next[k] = true;
        return next;
      });
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [toc]);

  useEffect(() => {
    const handleMove = (e: MouseEvent) => {
      const btn = (e.target as HTMLElement).closest('.menual-move');
      if (!btn) return;
      const key = (btn as HTMLElement).dataset.menual;
      if (!key) return;
      const target = document.querySelector(`.menual-target[data-menual="${key}"]`);
      if (!target) return;
      const isHeaderTarget = target.closest('.header');
      if (!isHeaderTarget) {
        const offset = 200;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
      target.classList.add('menual-target-active');
      window.setTimeout(() => {
        target.classList.remove('menual-target-active');
      }, 2800);
    };
    document.addEventListener('click', handleMove);
    return () => document.removeEventListener('click', handleMove);
  }, []);

  return (
    <div className="menual-area">
      <div className="menual-w">
        <button
          type="button"
          className="menual-close"
          onClick={() => {
            document.documentElement.classList.remove('menual-active');
            clearPersistedState({ keepOpen: false });
          }}
        >
          닫기
        </button>
        <div className="menual">
          {/* 목차 영역 */}
          <div className={`menual-nav-area${tocOpen ? ' active' : ''}`}>
            <div className="menual-nav-head">
              <strong>{title}</strong>
              <button
                type="button"
                className="menual-nav-control"
                onClick={() => setTocOpen((v) => !v)}
              />
            </div>
            <AnimatedCollapse isOpen={tocOpen} className="menual-nav-w">
              {toc.length > 0
                ? <TocList items={toc} onNavClick={handleNavClick} />
                : <p className="txt sm">준비 중입니다.</p>
              }
            </AnimatedCollapse>
          </div>

          {/* 상세 패널 영역 */}
          <PanelTree
            items={toc}
            openPanels={openPanels}
            togglePanel={togglePanel}
            onMoveTop={handleMoveTop}
            portal={portal}
          />
        </div>
      </div>
    </div>
  );
};

export default UserManualSidebar;
